import React, { ChangeEvent, Component } from "react";
import { WebFormFieldProps } from "./index";
import { readError, readValue, writeValue } from "@eres/forms/Utils";
import { DefaultProps } from "@eres/forms";

interface Props extends WebFormFieldProps<boolean, boolean> {
	inputClassName?: string;
	errorInputClass?: string;
}

class CheckBoxField extends Component<Props> {
	static defaultProps: DefaultProps<Props> = {
        containerClassName: "form-check",
        inputClassName: "form-check-input",
        labelClassName: "form-check-label",
		errorInputClass: "form-input-error",
		errorClassName: "invalid-feedback invalid-feedback-x"
	};

	onChange = ( event: ChangeEvent<HTMLInputElement> ) => {
		let value = event.target.checked;
		if ( this.props.onValueChange ) {
			this.props.onValueChange( value );
		}
		writeValue( this.props, value );
	};

	render() {
		const {
			id,
			containerClassName,
			inputClassName,
			labelClassName,
			label,
			required,
			error,
			errorInputClass,
			errorClassName
		} = this.props;
		const inpProps = {
			id: id,
			onChange: this.onChange,
			className: inputClassName + ( error ? ` ${ errorInputClass }` : "" ),
			type: "checkbox",
			checked: readValue( this.props ),
		};
		let xError = error;
		if ( error == null )
			xError = readError( this.props );
		return (
			<React.Fragment>
				<div className={ containerClassName }>
					<input { ...inpProps }/>
					<label className={ labelClassName } htmlFor={ id }><span>{ label }</span>
						{ required && <span className="asterisk">*</span> }
					</label>
					{ xError && <div className={ errorClassName }>{ xError }</div> }
				</div>

			</React.Fragment>
		);
	}
}

export default CheckBoxField;
